import React from 'react'
// libs
import styled from 'styled-components'
import ReCAPTCHA from 'react-google-recaptcha'
import { Helmet } from 'react-helmet-async'
import { useRouter } from 'hooks/useRouter'
import { clearAccessToken } from 'lib/auth'
// hooks
import { useRisksAPI } from 'hooks/risks/useRiskAPI'
import { useRecaptcha } from 'hooks/useRecaptcha'
// components
import PageLoader from 'components/UI/Loader/PageLoader'
// views
import { Header, Logo, LogoContainer } from 'components/PageComponents/Risks/PublicEdit/views'

const Wrapper = styled.div`
  height: calc(100dvh - 64px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 40px;
  font-size: 20px;
`

const PublicRiskCreatePage: React.FC = () => {
  const router = useRouter()

  const [loading, setLoading] = React.useState(false)

  const { createPublicRisk } = useRisksAPI()

  const { recaptchaRef, handleRecaptcha } = useRecaptcha()

  const onRiskCreate = async (accessToken: string) => {
    setLoading(true)

    const templateId = router.query.id as string

    const { id } = await createPublicRisk(
      {
        domain: router.query.domain as string,
        input: {
          riskTemplateId: templateId
        }
      },
      accessToken
    )

    if (id) {
      router.push(`/public/form/${id}?templateId=${templateId}&domain=${router.query.domain}`)
    }
  }

  const onRecaptchaEnter = async (token: string) => {
    const accessToken = await handleRecaptcha(token)

    onRiskCreate(accessToken)
  }

  React.useEffect(() => {
    clearAccessToken()
  }, [])

  return (
    <>
      <Helmet>
        <title>Skefto - Edit Form</title>
      </Helmet>
      <Header>
        <LogoContainer>
          <Logo />
        </LogoContainer>
      </Header>
      {loading ? (
        <PageLoader isLoading />
      ) : (
        <Wrapper>
          <span>Please complete the check before proceeding.</span>
          <ReCAPTCHA ref={recaptchaRef} sitekey={import.meta.env.VITE_RECAPTCHA_KEY} onChange={onRecaptchaEnter} />
        </Wrapper>
      )}
    </>
  )
}


export default PublicRiskCreatePage
